import { Params } from "react-router-dom";
import client from "./axios";
import { User } from "../models/User";

const patientsUrl = `${window.__env.BASE_URL}/me`;

export const Me = {
  getMeCalendar: (from: String, to: String, params: any) => client.get(`${patientsUrl}/schedule/${from}/${to}`, params),

}